import { HttpRequest } from '../../../../../types/rest/analyticsTypes';
import { DetailTabType } from '../../analyticsUiTypes';

export const SELECT_HTTP_CALLS_VIEW_TRIGGER = 'SELECT_HTTP_VIEW_TRIGGER';
export const SET_HTTP_CALLS_ACTIVE_PAGE = 'SET_HTTP_CALLS_ACTIVE_PAGE';
export const SET_HTTP_CALLS_PAGE_SIZE = 'SET_HTTP_CALLS_PAGE_SIZE';
export const SET_HTTP_CALLS_SEARCH_KEYWORD = 'SET_HTTP_CALLS_SEARCH_KEYWORD';
export const SELECT_HTTP_CALLS_DETAIL_TAB = 'SELECT_HTTP_CALLS_DETAIL_TAB';

export type SelectHttpViewTrigger = {
  type: typeof SELECT_HTTP_CALLS_VIEW_TRIGGER;
  payload: HttpRequest | null;
};
export type ChangeHttpCallsActivePage = {
  type: typeof SET_HTTP_CALLS_ACTIVE_PAGE;
  payload: number;
};
export type ChangeHttpCallsPageSize = {
  type: typeof SET_HTTP_CALLS_PAGE_SIZE;
  payload: number;
};
export type SelectHttpCallsDetailTab = {
  type: typeof SELECT_HTTP_CALLS_DETAIL_TAB;
  payload: DetailTabType;
};
export type SetHttpCallsSearchKeyword = {
  type: typeof SET_HTTP_CALLS_SEARCH_KEYWORD;
  payload: string;
};
export type HttpCallsActionTypes =
  | SelectHttpViewTrigger
  | ChangeHttpCallsActivePage
  | ChangeHttpCallsPageSize
  | SetHttpCallsSearchKeyword
  | SelectHttpCallsDetailTab;
